import React from 'react';
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import cn from 'classnames';
import { Box, Button, Flex, IconButton } from '@chakra-ui/react';
import { Icon } from 'components/Icons/iconObject';
import s from './Navigator.module.scss';
import navigationData from 'navigationData';
import { NavigationItem } from './navigationItem';
import { useMsal } from '@azure/msal-react';
import { useAuth } from 'components/Auth/AuthProvider';

interface NavLinkItemsProps {
  isMobile?: boolean;
  onClose?: () => void;
}
export const NavLinkItems = ({
  isMobile = false,
  onClose,
}: NavLinkItemsProps): JSX.Element => {
  const location = useLocation();
  const { instance } = useMsal();
  const { hasAccess, hasRoles } = useAuth();

  // TODO: Change when we have better access control
  // const isAdmin = hasAccess();

  return (
    <ul className={s.navigator}>
      {navigationData.map((item) => {
        if (item.restrictAccess && !hasRoles(item.restrictAccess)) {
          return null;
        }
        if (item.conditional && !hasAccess()) {
          return null;
        }
        const isParentActive =
          item.url !== '/' && location.pathname.startsWith(item.url);
        return (
          <NavigationItem
            onClose={onClose}
            key={`N_level_${item.elementId}`}
            icon={item.icon && Icon[item.icon]}
            active={isParentActive}
            subnav={
              isParentActive && item.children?.length ? (
                <ul
                  key={`sub_${item.elementId}`}
                  className={cn(s.navigator, s.subnav)}
                >
                  {item.children?.map((level2) => {
                    // console.log(level2);
                    if (
                      level2.restrictAccess &&
                      !hasRoles(level2.restrictAccess)
                    )
                      return null;
                    if (level2.conditional && !hasAccess()) return null;
                    return (
                      <NavigationItem
                        key={`n_item_${level2.elementId}`}
                        icon={Icon.subLevel}
                        active={
                          level2.url !== '/' &&
                          location.pathname.startsWith(level2.url)
                        }
                      >
                        {level2.external && (
                          <a href={level2.url}>{level2.label}</a>
                        )}
                        {!level2.external && (
                          <Link to={level2.url}>{level2.label}</Link>
                        )}
                      </NavigationItem>
                    );
                  })}
                </ul>
              ) : null
            }
          >
            {item.navigationLevel === 1 && (
              <Link to={item.url}>{item.label}</Link>
            )}
          </NavigationItem>
        );
      })}

      {isMobile && (
        <NavigationItem icon={Icon.logout} active={false}>
          <Button
            variant="unstyled"
            onClick={(): Promise<void> => instance.logout()}
          >
            Útskrá
          </Button>
        </NavigationItem>
      )}
    </ul>
  );
};

export const NavigatorComponent = (): JSX.Element => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleSidebar = (): void => setIsCollapsed((collapsed) => !collapsed);

  return (
    <nav className={cn(s.navigatorContainer, { [s.hide]: isCollapsed })}>
      <Box position="sticky" top="0">
        <Flex direction="column" paddingLeft="20px">
          <IconButton
            aria-label="toggle-button"
            size="xs"
            alignSelf="flex-end"
            className={s.navigatorToggleButton}
            icon={isCollapsed ? Icon.arrowRight : Icon.arrowLeft}
            color="font-light"
            onClick={toggleSidebar}
            variant="unstyled"
            padding="2"
          />

          <NavLinkItems />
        </Flex>
      </Box>
    </nav>
  );
};
